import useMediaQuery from './useMediaQuery'

/**
 * Is the app running installed to the home screen, rather than in a browser tab?
 *
 * Verified on an iPhone 14: installed, Safari's chrome is gone entirely — no
 * address bar, no bottom toolbar. That is what makes the PWA worth having,
 * because it removes the `100vh` class of bug at the source rather than working
 * around it.
 *
 * It also removes the **back button**, which is the part that matters for
 * layout. In a browser tab a user can always escape a screen with the browser's
 * own back; installed, they cannot. Every field screen therefore has to provide
 * its own way back, and that is not optional decoration.
 *
 * `display-mode: standalone` is the standard query. iOS historically needed
 * `navigator.standalone`, but modern iOS honours the media query, and the
 * fallback is checked too because it costs one line and iOS is where this
 * matters most.
 */
const useIsStandalone = (): boolean => {
	const matchesDisplayMode = useMediaQuery('(display-mode: standalone)')
	const iosLegacy =
		typeof navigator !== 'undefined' && (navigator as { standalone?: boolean }).standalone === true

	return matchesDisplayMode || iosLegacy
}

export default useIsStandalone
